var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background",style:(_vm.drawingZoneStyle),attrs:{"id":"EmojisDrawingZone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }